const Footer = () => {
  return (
    <div className="pb-4">
      <h5 className="mb-4 text-sm font-medium text-gray-600 sm:!mb-0 md:text-lg">
        <p className="mb-4 text-sm text-gray-600 sm:!mb-0 md:text-base">
          ©{new Date().getFullYear()} ControlFoods. Todos os direitos reservados.
        </p>
        <p className="mb-4 text-sm text-gray-600 sm:!mb-0 md:text-base">
          Feito por WDMF Consultoria de Negocios de Implementação de Sistemas LTDA
        </p>
      </h5>
    </div>
  );
};

export default Footer;
